/* eslint-disable @typescript-eslint/naming-convention */ // pre-commit-allow: PascalCase wire DTO (Sparta API casing), WI 36508

/** WI 36508: one saved dispatch or time line to check, an employee job and a date worked (or dispatch start). */
export interface PayrollReadinessCheckDto {
  EmployeeJobID: string;
  WorkDate: Date | string;
}

/** WI 36508: a warning, never a block, that the line will not export to Viewpoint payroll as things stand. */
export interface PayrollReadinessWarningDto {
  EmployeeJobID: string;
  EmployeeID: string;
  EmployeeName: string;
  WeekEnd: string;
  Kind: 'EmployeeMissing' | 'EmployeeInactive' | 'NoOpenPayPeriod';
  Message: string;
}
